import { styled, Typography } from "@mui/material";
import { useIntercom } from "react-use-intercom";
import { useEffect } from "react";
import { useConfiguration } from "../../dataAccess/api/configuration";
import { useLogout } from "../../dataAccess/HTTPClient";
import { ThemeButton } from "./ThemeComponents/ThemeButton";
import { TextButton } from "./TextButton";
import { useTranslation } from "../../helpers/i18n";
import { replaceBracesKey } from "../../helpers/formatter";

const Main = styled("div")(() => ({
  display: "flex",
  height: "100%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: "1rem",
}));

const ButtonsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: "1rem",
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: "2rem",
  letterSpacing: "0.2rem",
  fontSize: theme.typography.h2.fontSize,
  textAlign: "center",
  textTransform: "uppercase",
  opacity: "0.3",
}));

export const StyledText = styled(Typography)(() => ({
  maxWidth: "30rem",
  textAlign: "center",
}));

const StyledButton = styled(ThemeButton)(() => ({
  marginTop: "1rem",
}));

const UnderlineButton = styled(TextButton)(() => ({
  textDecoration: "underline",
}));

const RequestAccess = () => {
  const { t } = useTranslation();
  const { show, update } = useIntercom();
  const { configuration } = useConfiguration();
  const logout = useLogout(configuration?.isOpenMarketplace);

  useEffect(() => {
    update({
      hideDefaultLauncher: false,
    });
  }, []);

  return (
    <Main>
      <Title variant="h1">{t("information_account_under_review")}</Title>
      <StyledText>{t("information_access_requested")}</StyledText>
      {configuration?.website && (
        <StyledButton href={configuration.website}>
          {replaceBracesKey(t("information_go_back_to_company_website"), {
            key: "company_website",
            value: configuration.website.replace(/(^\w+:|^)\/\//, ""),
          })}
        </StyledButton>
      )}
      <ButtonsContainer>
        <UnderlineButton onClick={show}>
          {t("information_contact_us")}
        </UnderlineButton>
        <UnderlineButton onClick={() => logout()}>
          {t("information_sign_out")}
        </UnderlineButton>
      </ButtonsContainer>
    </Main>
  );
};

export default RequestAccess;
